// Shared by the fixed-frame editor and its tests. Never changes public layout sizes.
export function cropRect(width,height,ratio,{x=50,y=50,zoom=1}={}){
 if(![width,height,ratio,x,y,zoom].every(Number.isFinite)||width<=0||height<=0||ratio<=0||x<0||x>100||y<0||y>100||zoom<1||zoom>4)throw Error('Invalid crop.');
 const w=Math.min(width,height*ratio)/zoom,h=w/ratio;
 return {sx:(width-w)*x/100,sy:(height-h)*y/100,sw:w,sh:h};
}
export function loadImage(url){return new Promise((resolve,reject)=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=()=>reject(Error('This image cannot be opened for cropping. Upload the original JPG, PNG, or WebP file instead.'));img.src=url;});}
export function drawCrop(canvas,img,ratio,crop){
 const r=cropRect(img.naturalWidth,img.naturalHeight,ratio,crop);
 const width=Math.min(1600,Math.round(r.sw));
 canvas.width=Math.max(1,width);canvas.height=Math.max(1,Math.round(width/ratio));
 const ctx=canvas.getContext('2d');ctx.clearRect(0,0,canvas.width,canvas.height);
 ctx.drawImage(img,r.sx,r.sy,r.sw,r.sh,0,0,canvas.width,canvas.height);
}
export async function cropBlob(img,ratio,crop){
 const canvas=document.createElement('canvas');drawCrop(canvas,img,ratio,crop);
 return new Promise((resolve,reject)=>{try{canvas.toBlob(blob=>blob?resolve(blob):reject(Error('Could not create cropped image.')),'image/webp',.9);}catch{reject(Error('This image host does not allow cropping. Upload the original file instead.'));}});
}
